import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b1a8515"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "schoolHome" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name glBold" }, "Bojun CHENG", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Hongkong University of Science and Technology(Guangzhou)", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "rit" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div id=\"about\" class=\"nep glBold\" data-v-6b1a8515>Neuromorphic Electronics &amp; Photonics Lab</div><div class=\"ncm\" data-v-6b1a8515>Neuromorphic Computing | Memristor | IC design | Optical Neural Networks </div><div class=\"sec\" data-v-6b1a8515></div><div class=\"txtSec glBold\" data-v-6b1a8515>BIOGRAPHY</div><div data-v-6b1a8515>Bojun Cheng is an Assistant Professor in the Thrust of Microelectronics of the Function Hub at the Hong Kong University of Science and Technology (Guangzhou), China. He received his B.E. from School of the Gifted Young, University of Science and Technology of China in 2012, and Ph.D. from the ETH Zurich in 2021 (advised by Prof. Juerg Leuthold). His research has mainly focused on memristive devices and memristor-based neuromorphic computing, and optical interconnects for neuromorphic computing chips. </div><div class=\"sec\" data-v-6b1a8515></div><div class=\"txtSec glBold\" data-v-6b1a8515>Roles</div>", 7)
const _hoisted_15 = { class: "secCon" }
const _hoisted_16 = { class: "rolVal" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "Research",
  class: "sec"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txtSec glBold" }, "RESEARCH", -1))
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "secCon" }
const _hoisted_22 = { class: "rsTit glBold" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "ml12" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt32 txtIn glBold" }, "Interests", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lh24 mb16" }, [
  /*#__PURE__*/_createTextVNode("Memristive Computing Devices"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Neuromorphic In-Memory Computing Circuits and Algorithms"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Event-based Sensor and Applications")
], -1))
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"mt24\" data-v-6b1a8515>Welcome to <span class=\"txtNe glBold\" data-v-6b1a8515>Neuromorphic Electronics &amp; Photonics Lab</span> led by Prof. Bojun Cheng, in the Microelectronics Thrust of Function HUB at The Hong Kong University of Science and Technology (Guangzhou) . </div><div class=\"mt16 txtIn glBold\" data-v-6b1a8515>Breakthrough Von Neumann Architecture </div><div data-v-6b1a8515>With the computer application expansion and the explosive growth of data, the limitation of computing power and efficiency induced by traditional von Neumann architecture in the 21st century has imposed a urgent demand to be solved. From both bottom up to top down, the lab devote to build New Computing Architecture, New Computing Circuit, New Computing Device. The mission now is focus on (i) the construction of Neural Networks structure based on integrating optical and electrical system. (ii) the Implementation of in-memory computing circuit and system (iii) the design of event-driven new algorithm architecture. With the new memristor components and the new CIM architecture, the energy efficiency and computing power of the computer can be fundamentally improved. Starting from brain, neuromorphic computing provides a promising solution for future AI developments and will greatly change our life.</div><div id=\"Publications\" class=\"sec\" data-v-6b1a8515></div><div class=\"txtSec glBold\" data-v-6b1a8515>LATEST ACHIEVEMENTS</div><div class=\"recentCon\" data-v-6b1a8515><div class=\"itRecent\" data-v-6b1a8515><div class=\"recentTag isscc\" data-v-6b1a8515>ISSCC 2025</div><div class=\"recentTit\" data-v-6b1a8515>SpikeRAM: A 48.1pW/Synapse/Bit Memory-Centric Neuromorphic System with Perception, Computing and On-Chip Learning</div><div class=\"recentAuth\" data-v-6b1a8515>H. Fu et al., Symposium on VLSI Technology and Circuits, Kyoto, Japan, 2025</div><div class=\"recentDesc\" data-v-6b1a8515>SpikeRAM is a high-efficiency (48.1pW/Synapse/Bit) memory-centric neuromorphic system with perception, computing and on-chip learning capabilities. It achieves 464M synapses and 8.28mW power in real-time processing while realizing few-shot learning for event-based signature verification. The EVS-sCNN core enables asynchronous sensing and feature extraction, while the sFC-OCL core enables event-driven inference and learning with e-OTBP algorithm. Gray-code weights and ternary gradients reduce over 86% memory writing times.</div></div><div class=\"itRecent\" data-v-6b1a8515><div class=\"recentTag nature\" data-v-6b1a8515>Nature Electronics 2026</div><div class=\"recentTit\" data-v-6b1a8515>Photonically linked three-dimensional neural networks based on memristive blinking neurons</div><div class=\"recentAuth\" data-v-6b1a8515>Y. Zhou, Y. Fang, R. Gisler et al., Nature Electronics, 2026, 9: 93-102</div><div class=\"recentDesc\" data-v-6b1a8515>This work demonstrates that memristive blinking neurons can build scalable photonically linked 3D neural networks. The network achieves 91.51% accuracy on Google Speech and 92.27% on MNIST classification.</div></div></div><div class=\"txtSec glBold\" data-v-6b1a8515>PUBLICATIONS</div>", 7)
const _hoisted_35 = { class: "puCon" }
const _hoisted_36 = { class: "itPub" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "pubLab" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sec" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txtSec glBold" }, "Journal List", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "People",
  class: "sec"
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txtSec glBold" }, "PEOPLE", -1))
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt32 txtIn glBold" }, "Ph.D", -1))
const _hoisted_45 = { class: "phdCon" }
const _hoisted_46 = { class: "itPhd" }
const _hoisted_47 = { class: "icPhdCon" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "hvCon" }
const _hoisted_50 = { class: "hvTit glBold" }
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml4" }, "Research Direction", -1))
const _hoisted_53 = { class: "phdLab glBold" }
const _hoisted_54 = ["src"]

import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination, A11y } from 'swiper/modules';

import { MyImage } from "@icon/MyImage";

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const modules = [Autoplay, Pagination, Navigation, A11y];
const navigation = ref({
  nextEl: '.button-next',
  prevEl: '.button-prev',
})

const prevEl = () => {
  // console.log('上一张' + index + item)
}
const nextEl = () => {
  // console.log('下一张')
}
const sw = [
  { ic: MyImage.school.sw1 },
  { ic: MyImage.school.sw2 },
  { ic: MyImage.school.sw3 },
]

const clkContact = () => {
  window.open('https://www.' + des[1].lab.split('@')[1])
}

const des = [
  { ic: MyImage.school.mf, lab: "Microelectronics | Function hub" },
  { ic: MyImage.school.bu, lab: "bocheng@hkust-gz.edu.cn" },
  { ic: MyImage.school.hg, lab: "HKUST-GZ W3" },
];

const rol = [
  {
    ic: MyImage.school.pi,
    lab: "PRINCIPAL INVESTIGATOR",
    val: "Neuromorphic Electronics & Photonics Lab, Hong Kong University of Science and Technology (Guangzhou)",
  },
  {
    ic: MyImage.school.ac,
    lab: "ADVISORY COMMITTEE",
    val: "Novel IC Exploration Center, Hong Kong University of Science and Technology (Guangzhou)",
  },
  {
    ic: MyImage.school.ff,
    lab: "FOUNDING FACULTY",
    val: "Materials Characterization and Preparation Facility, Hong Kong University of Science and Technology (Guangzhou)",
  },
];

const tp = [
  { ic: MyImage.school.rsAl, lab: "Algorithm", val: [{ lab: 'Event-based Vision' }, { lab: 'Image Reconstruction' }, { lab: 'PointCloud' }, { lab: 'Multi-modality' },], bg: "var(--colorApp)" },
  { ic: MyImage.school.rsCi, lab: "Circuit", val: [{ lab: 'Mixed-Signal Processing' }, { lab: 'Hard&Software Co-design' }, { lab: 'Neuromorphic Circuit' }, { lab: 'Compute in Memory' },], bg: "#FFE699" },
  { ic: MyImage.school.rsDe, lab: "Device", val: [{ lab: 'Memristor device' }, { lab: 'Optoelectronics' }, { lab: 'Optics Physics' }, { lab: 'Nanofab Tech' },], bg: "#F8DADC" },
]

const pub = [
  { ic: MyImage.school.pubAs, lab: "Atomic scale memristive photon source", },
  { ic: MyImage.school.pubMc, lab: "Metasurface Colloidal Quantum Dot Photodetectors", },
  { ic: MyImage.school.pubAs, lab: "Threshold Switching Enabled Sub-pW-Leakage, Hysteresis-Free Circuits", },
  { ic: MyImage.school.pubOm, lab: "Opto-electronic memristors: Prospects and challenges in neuromorphic computing", },
  { ic: MyImage.school.pubBh, lab: "Broadband, High-Temperature Stable Reflector for Aerospace Thermal Radiation Protection", },
  { ic: MyImage.school.pubMp, lab: "MEMS Plasmonics and Memristive Plasmonics for Optical Communications", },
  { ic: MyImage.school.pubAsp, lab: "Atomic Scale Photodetection Enabled by a Memristive Junction", },
  { ic: MyImage.school.pubEt, lab: "Electrically Tunable Graphene Organic Hybrid Ring Resonators", },
]

const jl = [
  { lab: "[1] Zhou, Y., Fang, Y., Gisler, R. et al. Photonically linked three-dimensional neural networks based on memristive blinking neurons[J]. Nat Electron, 2026, 9: 93-102, doi: 10.1038/s41928-025-01529-5." },
  { lab: "[2] Huang Y, Tang J, Wang C, et al. Spikingmamba: Towards energy-efficient large language models via knowledge distillation from mamba[J]. Transactions on Machine Learning Research (TMLR), 2025." },
  { lab: "[3] Ren H, Lin X, Huang H, et al. Exploring Temporal Dynamics in Event-based Eye Tracker[J]. arXiv preprint arXiv:2503.23725, 2025." },
  { lab: "[4] H. Fu et al., \"NeuC-CIM: A 1.3pJ/SOP Neuromorphic Charge-Domain Compute-in-Memory Macro for Spiking Neural Network,\" in 2025 Symposium on VLSI Technology and Circuits (VLSI Technology and Circuits), Kyoto, Japan, 2025, pp. 1-3, doi: 10.23919/VLSITechnologyandCir65189.2025.11074927." },
  { lab: "[5] H. Ren et al., \"Rethinking Efficient and Effective Point-Based Networks for Event Camera Classification and Regression,\" in IEEE Transactions on Pattern Analysis and Machine Intelligence, vol. 47, no. 8, pp. 6228-6241, Aug. 2025, doi: 10.1109/TPAMI.2025.3556561." },
  { lab: "[6] Lin X, Huang Y, Ren H, et al. ClearSight: Human vision-inspired solutions for event-based motion deblurring[C]//Proceedings of IEEE/CVF International Conference on Computer Vision. 2025: 7462-7471." },
  { lab: "[7] Huang H, Lin X, Ren H, et al. Exploring Temporal Dynamics in Event-based Eye Tracker[C]//Proceedings of Computer Vision and Pattern Recognition Conference. 2025: 5145-5154." },
  { lab: "[8] Malchow K, Zellweger T, Cheng B, et al. Self-induced light emission in solid-state memristors replicates neuronal biophotons[J]. ACS nano, 2024, 18(35): 24004-24011." },
  { lab: "[9] Chen T, Wang W, Chen J, et al. PipeCIM: A High-Throughput Computing-In-Memory Microprocessor With Nested Pipeline and RISC-V Extended Instructions[J]. IEEE Transactions on Circuits and Systems I: Regular Papers, 2024." },
  { lab: "[10] Lewerenz M, Passerini E, Cheng B, et al. Versatile Nanoscale Three-Terminal Memristive Switch Enabled by Gating[J]. ACS nano, 2024, 18(16): 10798-10806." },
  { lab: "[11] Ren H, Zhu J, Zhou Y, et al. A simple and effective point-based network for event camera 6-dofs pose relocalization[C]//Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition. 2024: 18112-18121." },
  { lab: "[12] Huang Y, Lin X, Ren H, et al. CLIF: Complementary leaky integrate-and-fire Neuron for spiking neural networks[J]. arXiv preprint arXiv:2402.04663, 2024." },
  { lab: "[13] Fu H, Huang Y, Chen T, et al. DS-CIM: A 40nm asynchronous dual-spike driven, MRAM compute-in-memory macro for spiking neural network[J]. IEEE Transactions on Circuits and Systems I: Regular Papers, 2024, 71(4): 1638-1650." },
  { lab: "[14] Yi W, Mo K, Wang W, et al. RDCIM: RISC-V supported full-digital computing-in-memory processor with high energy efficiency and low area overhead[J]. IEEE Transactions on Circuits and Systems I: Regular Papers, 2024, 71(4): 1719-1732." },
  { lab: "[15] Lin X, Ren H, Cheng B. Fapnet: An effective frequency adaptive point-based eye tracker[C]//Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition. 2024: 5789-5798." },
  { lab: "[16] Wang Z, Gao C, Wu Z, et al. Event-based eye tracking. AIS 2024 challenge survey[C]//Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition. 2024: 5810-5825." },
  { lab: "[17] Ren H, Zhou Y, Fu H, et al. TTPOINT: A Tensorized Point Cloud Network for Lightweight Action Recognition with Event Cameras[C]//Proceedings of the 31st ACM International Conference on Multimedia. 2023: 8026-8034." },
  { lab: "[18]Ren H, Zhou Y, Huang Y, et al. SpikePoint: An Efficient Point-based Spiking Neural Network for Event Cameras Action Recognition[J]. arXiv preprint arXiv:2310.07189, 2023." },
  { lab: "[19]Hamdad S, Malchow K, Avetisyan D, et al. Overbias and Quantum Tunneling in Light-Emitting Memristors[J]. Physical Review Applied, 2023, 20(2): 024057." },
  { lab: "[20]Malchow K, Hamdad S, Cheng B, et al. Light in Memristive Atomic Scale Junction-Memristors go Photonics[C]//EPJ Web of Conferences. EDP Sciences, 2023, 287: 14004." },
  { lab: "[21]Wan Q, Wan C, Wu H, et al. 2022 roadmap on neuromorphic devices and applications research in China[J].Neuromorphic Computing and Engineering, 2022, 2(4): 042501." },
  { lab: "[22] N. Dordevic et al., \"Metasurface Colloidal Quantum Dot Photodetectors,\" ACS Photonics, vol. 9, no. 2, pp. 482-492, Feb 2022." },
  { lab: "[23] B. J. Cheng et al., \"Atomic scale memristive photon source,\" Light-Science & Applications, vol. 11, no. 1, Mar 2022, Art. no. 78." },
  { lab: "[24] P. Ma et al., \"Electrically Tunable Graphene Organic Hybrid Ring Resonators,\" in 2021 IEEE Photonics Conference (IPC), 2021, pp. 1-2. " },
  { lab: "[25] M. Lewerenz et al., \"Gate-Enabled Operation Point Tuning in an Atomic-Scale Memristor,\" presented at the 4th International Conference on Memristive Materials, Devices & Systems (MEMRISYS 2021), Tsukuba, Japan, November 1-4, 2021, 2021. Available: http: //hdl.handle.net/20.500.11850/526436" },
  { lab: "[26] B. J. Cheng et al., \"Threshold Switching Enabled Sub-pW-Leakage, Hysteresis-Free Circuits,\" Ieee Transactions on Electron Devices, vol. 68, no. 6, pp. 3112-3118, Jun 2021." },
  { lab: "[27] J. Leuthold et al., \"MEMS Plasmonics and Memristive Plasmonics for Optical Communications,\" in European Conference on Optical Communications (ECOC), Electr Network, 2020, 2020. " },
  { lab: "[28] J. Leuthold et al., \"Atomic-Scale Photonic Memristive and Nano-Opto-Electro-Mechanical Devices Enabled by Plasmonics,\" in Frontiers in Optics / Laser Science, Washington, DC, 2020, p. FW7D.1: Optica Publishing Group. " },
  { lab: "[29] A. Emboras et al., \"Opto-electronic memristors: Prospects and challenges in neuromorphic computing,\" Applied Physics Letters, vol. z17, no. 23, Dec 2020, Art. no. 230502. " },
  { lab: "[30] G. Christidis et al., \"Broadband, High-Temperature Stable Reflector for Aerospace Thermal Radiation Protection,\" ACS Applied Materials & Interfaces, vol. 12, no. 8, pp. 9925-9934, Feb 2020. " },
  { lab: "[31] G. Christidis et al., \"Broadband, Temperature-Stable, Reflective Additives to Enhance Thermal Radiation Protection Systems,\" in OSA Advanced Photonics Congress (AP) 2020 (IPR, NP, NOMA, Networks, PVLED, PSC, SPPCom, SOF), Washington, DC, 2020, p. NoTu2C.4: Optica Publishing Group. " },
  { lab: "[32] B. J. Cheng et al., \"Ultra-steep-slope transistor enabled by an atomic memristive switch,\" in Conference on Nanoengineering - Fabrication, Properties, Optics, Thin Films, and Devices XVII, Electr Network, 2020, vol. 11467, 2020. " },
  { lab: "[33] C. Weilenmann et al., \"Investigation of light-controlled filament dynamics in an electro-optical memristive photodetector (Conference Presentation),\" in Integrated Optics: Design, Devices, Systems, and Applications V, 2019, vol. 11031, p. 110310C: SPIE. " },
  { lab: "[34] Y. Salamin et al., \"Plasmonics in Silicon Photonics for Microwave Photonics,\" presented at the 10th International Conference on Metamaterials, Photonic Crystals and Plasmonics (META 2019), Lisbon, Portugal, July 23-26, 2019, 2019. Available: http: //hdl.handle.net/20.500.11850/365735" },
  { lab: "[35] B. J. Cheng et al., \"Ultra compact electrochemical metallization cells offering reproducible atomic scale memristive switching,\" Communications Physics, vol. 2, Mar 2019, Art. no. 28. " },
  { lab: "[36] Y. Salamin et al., \"100 GHz Plasmonic Photodetector,\" ACS Photonics, vol. 5, no. 8, pp. 3291-3297, Aug 2018. " },
  { lab: "[37] J. Leuthold et al., \"Single atom electronics and photonics (Conference Presentation),\" in Silicon Photonics: From Fundamental Research to Manufacturing, 2018, vol. 10686, p. 1068605: SPIE. " },
  { lab: "[38] C. Haffner et al., \"Low-loss plasmon-assisted electro-optic modulator,\" Nature, vol. 556, no. 7702, pp. 483-+, Apr 2018. " },
  { lab: "[39] C. Haffner et al., \"Bypassing Loss in Plasmonic Modulators,\" in Conference on Lasers and Electro-Optics (CLEO), San Jose, CA, 2018, 2018. " },
  { lab: "[40] A. Emboras et al., \"Atomic Scale Photodetection Enabled by a Memristive Junction,\" ACS Nano, vol. 12, no. 7, pp. 6706-6713, Jul 2018. " },
  { lab: "[41] Y. Salamin et al., \"High speed photoconductive plasmonic germanium detector,\" in CLEO: Science and Innovations, 2017, p. STu1N. 2: Optical Society of America. " },
  { lab: "[42] W. Heni et al., \"Nonlinearities of organic electro-optic materials in nanoscale slots and implications for the optimum modulator design,\" Optics Express, vol. 25, no. 3, pp. 2627-2653, Feb 2017. " },
  { lab: "[43] F. Ducry et al., \"Ab-initio modeling of CBRAM cells: From ballistic transport properties to electro-thermal effects,\" in 2017 IEEE International Electron Devices Meeting (IEDM), 2017, pp. 4.2. 1-4.2. 4: IEEE. " },
  { lab: "[44] A. Emboras et al., \"Atomic Photodetection,\" in Conference on Lasers and Electro-Optics (CLEO), San Jose, CA, 2016, 2016. " },
  { lab: "[45] A. Emboras et al., \"Atomic Scale Plasmonic Devices,\" in 18th International Conference on Transparent Optical Networks (ICTON), Univ Trento, Fac Letters & Philosophy, Trento, ITALY, 2016, 2016. " },
]

const phd = [
  { ic: MyImage.school.yz, lab: "Yue ZHOU", val: "optoelectronics device\nmemristor, nano fabrication" },
  { ic: MyImage.school.hwr, lab: "Hongwei Reng", val: "Event cameras, Spiking Nerual Network\nPoint Cloud\nSimultaneous Localization and Mapping" },
  { ic: MyImage.school.htf, lab: "Haotian Fu", val: "Neuromorphic Circuit Design\nCompute-In-Memory\nMixed-Signal Processing" },
  { ic: MyImage.school.ylh, lab: "Yulong Huang", val: "Neuromorphic Computing\nSpiking Neural Network " },
  { ic: MyImage.school.zcl, lab: "Zunchang Liu", val: "Event Cameras Vision\nImage Reconstruction" },
  { ic: MyImage.school.xpl, lab: "Xiaopeng Lin", val: "Event-based Image Reconstruction\nMulti-sensor Image Fusion\nNeuromorphic Computing" },
  { ic: MyImage.school.hzz, lab: "Hongzhao ZHENG", val: "Spiking-based In-Memory Computing" },
  { ic: MyImage.school.hxh, lab: "Hongxiang Huang", val: "Event Camera\nMoving Object Segmentation" },
  { ic: MyImage.school.zlm, lab: "Zelin Ma", val: "Memristor Fabrication\nReservoir Computing\nProbabilistic Computing" },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(MyImage).school.ava,
        alt: ""
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _hoisted_5,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(des, (it, i) => {
        return _createElementVNode("div", {
          key: it.lab,
          class: _normalizeClass(["it glBold", i == 0 ? 'itMl' : ''])
        }, [
          _createElementVNode("img", {
            src: it.ic,
            alt: ""
          }, null, 8, _hoisted_6),
          _createElementVNode("div", null, _toDisplayString(it.lab), 1)
        ], 2)
      }), 64)),
      _createElementVNode("button", {
        class: "glMyBtn btn",
        onClick: clkContact
      }, "Contact")
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rol, (it, i) => {
          return _createElementVNode("div", {
            key: it.lab,
            class: _normalizeClass(["itRol", i == 0 ? 'itRolOn' : ''])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["rolTit glBold", i == 0 ? 'rolTitOn' : ''])
            }, _toDisplayString(it.lab), 3),
            _createElementVNode("div", _hoisted_16, _toDisplayString(it.val), 1),
            _createElementVNode("img", {
              src: it.ic,
              alt: "",
              class: "rolIc"
            }, null, 8, _hoisted_17)
          ], 2)
        }), 64))
      ]),
      _hoisted_18,
      _hoisted_19,
      _createElementVNode("img", {
        src: _unref(MyImage).school.tp,
        alt: "",
        class: "icRsTp"
      }, null, 8, _hoisted_20),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tp, (it, i) => {
          return _createElementVNode("div", {
            key: it.lab,
            class: "itRs",
            style: _normalizeStyle({ backgroundColor: it.bg })
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("img", {
                src: it.ic,
                alt: ""
              }, null, 8, _hoisted_23),
              _createElementVNode("div", _hoisted_24, _toDisplayString(it.lab), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.val, (e) => {
              return (_openBlock(), _createElementBlock("div", {
                key: e.lab,
                class: _normalizeClass(["itRsVal", i == 0 ? 'bdWh' : ''])
              }, _toDisplayString(e.lab), 3))
            }), 128))
          ], 4)
        }), 64))
      ]),
      _hoisted_25,
      _hoisted_26,
      _createVNode(_unref(Swiper), {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: navigation.value,
        loop: true,
        centeredSlides: false,
        autoplay: { delay: 2000, disableOnInteraction: false },
        class: "mySwiper",
        modules: modules
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sw, (it, i) => {
            return _createVNode(_unref(SwiperSlide), { key: i }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: it.ic,
                  alt: "",
                  class: "icSw"
                }, null, 8, _hoisted_27)
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      }, 8, ["navigation"]),
      _hoisted_28,
      _createElementVNode("div", _hoisted_35, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pub, (it) => {
          return _createElementVNode("div", _hoisted_36, [
            _createElementVNode("img", {
              src: it.ic,
              alt: ""
            }, null, 8, _hoisted_37),
            _createElementVNode("div", _hoisted_38, _toDisplayString(it.lab), 1)
          ])
        }), 64))
      ]),
      _hoisted_39,
      _hoisted_40,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(jl, (it) => {
        return _createElementVNode("div", {
          key: it.lab,
          class: "itJl"
        }, _toDisplayString(it.lab), 1)
      }), 64)),
      _hoisted_41,
      _hoisted_42,
      _createElementVNode("img", {
        src: _unref(MyImage).school.pp,
        alt: ""
      }, null, 8, _hoisted_43),
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(phd, (it) => {
          return _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("img", {
                src: it.ic,
                alt: ""
              }, null, 8, _hoisted_48),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("img", {
                    src: _unref(MyImage).school.star,
                    alt: ""
                  }, null, 8, _hoisted_51),
                  _hoisted_52
                ]),
                _createElementVNode("div", null, _toDisplayString(it.val), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_53, _toDisplayString(it.lab), 1)
          ])
        }), 64))
      ]),
      _createElementVNode("img", {
        src: _unref(MyImage).school.ju,
        alt: ""
      }, null, 8, _hoisted_54)
    ])
  ]))
}
}

})